import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TableService } from '../../services/integrated/table.service';
import { Globals } from '../../globals';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
    selector: 'app-content',
    templateUrl: './content.component.html',
    styleUrls: ['./content.component.css'],
})
export class ContentComponent implements OnInit {
    public cstbcontent = new TableService();
    public connect;
    public width;
    private list = [];
    public token: any = {

        getcontent: "api/getlistcontent",
        getlistByGroupContent: "api/getlistcontentByGroup",

    }
    constructor(public globals: Globals, public route: ActivatedRoute, ) {
        this.width = document.body.getBoundingClientRect().width
        this.connect = this.globals.result.subscribe((res: any) => {
            switch (res.token) {
                case "getcontentbygroup":
                    if (res.data.length > 0) {
                        this.list = res.data;
                        this.cstbcontent._ini({ data: this.list, count: 15, pages: 1 });
                        this.cstbcontent.sorting.field = '';
                    }
                    break;
                default:
                    break;
            }
        });
    }
    ngOnInit() {

        this.route.params.subscribe(params => {
            let parent_link = params.parent_link;
            if (parent_link && parent_link.length > 0) {
                this.getListContentgrop(parent_link)
            } else { this.getListContent() }
        })
    }
    getListContent() {
        this.globals.send({ path: this.token.getcontent, token: "getcontent" });

    }
    getListContentgrop(link) {
        this.globals.send({ path: this.token.getlistByGroupContent, token: "getcontentbygroup", params: { link: link } });

    }
}



// WEBPACK FOOTER //
// ./src/app/frontend/content/content.component.ts